import { createFileRoute } from '@tanstack/react-router';
import Blueprints from 'src/pages/Organization/Blueprints';

export const Route = createFileRoute('/$organizationSlug/blueprints/$')({
  component: () => (
    <Blueprints components={{ withItemCreation: true, withTitle: true }} />
  ),
});
